/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined'
import FlagIcon from '@material-ui/icons/Flag'
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'

export default [
  {
    pages: [
      {
        title: 'Pending Accounts',
        href: '/pending-accounts',
        icon: PermIdentityOutlinedIcon
      },
      {
        title: 'Pending Campaigns',
        href: '/pending-campaigns',
        icon: FlagOutlinedIcon
      },
      {
        title: 'Manage Accounts',
        href: '/manage-accounts',
        icon: SupervisorAccountIcon
      },
      {
        title: 'Manage Campaigns',
        href: '/manage-campaigns',
        icon: FlagIcon
      }
    ]
  }
]
